// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { DepartmentListResponse } from "./types";

import * as departmentActions from "./department.actions";

export function* getDepartment(
  action: ReturnType<typeof departmentActions.getDepartmentAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + 'umn-department';
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: DepartmentListResponse = yield call(result.json.bind(result));
      yield put(departmentActions.getDepartmentAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(departmentActions.getDepartmentAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(departmentActions.getDepartmentAsync.failure(parsed));
  }
}

export default function* departmentSagaGetDepartment() {
  yield takeEvery(departmentActions.getDepartmentAsync.request, getDepartment);
}
